<div class="blog-widget">
  <article *ngFor="let article of blogPosts" class="short-article-widget">
    <div class="short-article--image">
      <app-webp-image [src]="getImageUrl(article)" [alt]="article.title"></app-webp-image>
    </div>
    <div class="short-article--content">
      <h4>{{ article.title }}</h4>
      <div class="blog-details--info">
        <p class="blog-details--date">
          <time>
            Veröffentlicht am <strong>{{ article.dateCreated | date:'dd.MM.YYYY' }}</strong>
          </time>
        </p>
      </div>
      <div [innerHtml]="excerpt(article)"></div>
      <div class="article-button text-right">
        <a class="button button-default" [routerLink]="['/', 'aktuelles', article.slug]">weiterlesen</a>
      </div>
    </div>
  </article>

  <div class="pagination" *ngIf="widget.data.postsPerPage && widget.data.postsPerPage > 0 && totalPages > 1">
    <button
      class="pagination-button"
      [disabled]="currentPage === 1"
      (click)="goToPage(currentPage - 1)">
      « Zurück
    </button>

    <button
      *ngIf="pages[0] > 1"
      class="pagination-button"
      (click)="goToPage(1)">
      1
    </button>

    <span *ngIf="pages[0] > 2" class="pagination-ellipsis">...</span>

    <button
      *ngFor="let page of pages"
      class="pagination-button"
      [class.active]="page === currentPage"
      (click)="goToPage(page)">
      {{ page }}
    </button>

    <span *ngIf="pages[pages.length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>

    <button
      *ngIf="pages[pages.length - 1] < totalPages"
      class="pagination-button"
      (click)="goToPage(totalPages)">
      {{ totalPages }}
    </button>

    <button
      class="pagination-button"
      [disabled]="currentPage === totalPages"
      (click)="goToPage(currentPage + 1)">
      Weiter »
    </button>
  </div>
</div>
